import CreateTemplateForm from './CreateTemplateForm';

export default CreateTemplateForm;
